<div class="stepper-container-hide-header">
	<mat-horizontal-stepper #stepper [linear]="true">
		<mat-step label="all">
			<div [style.overflow]="'auto'" class="table-container">
				<div fxLayout="row" fxLayoutAlign="start center" class="margin-top-10 margin-bottom-5 button-row">
					<mat-checkbox
						fxFlex="nogrow"
						aria-label="Checkbox to select all cases"
						class="master-checkbox-offset"
						(change)="masterToggle($event)"
						[checked]="selection.selected.length === systemicCaseArray?.length && selection.selected.length > 0"
						[indeterminate]="selection.selected.length > 0 && selection.selected.length < systemicCaseArray?.length"
						id="master-toogle"
					>
						{{ selection.selected.length }} of {{ systemicCaseArray?.length }} Selected
					</mat-checkbox>
					<button
						fxFlex="nogrow"
						mat-flat-button
						color="primary"
						id="subscribe-systemic-case-button"
						class="mat-button-sm margin-right-20"
						[disabled]="selection.selected.length === 0"
						appDebounceClick
						(debounceClick)="confirmSubscribe()"
					>
						SUBSCRIBE
					</button>
					<button
						fxFlex="nogrow"
						mat-flat-button
						color="primary"
						id="unsubscribe-systemic-case-button"
						class="mat-button-sm margin-right-20"
						[disabled]="selection.selected.length === 0"
						appDebounceClick
						(debounceClick)="confirmUnsubscribe()"
					>
						UNSUBSCRIBE
					</button>
					<button
						fxFlex="nogrow"
						mat-flat-button
						color="primary"
						id="remove-systemic-case-button"
						class="mat-button-sm margin-right-20"
						*ngIf="isEnableDelete(selection.selected)"
						appDebounceClick
						(debounceClick)="confirmRemoveSystemicCases(selection.selected, 'remove')"
					>
						REMOVE SYSTEMIC CASES
					</button>
				</div>
				<div role="status" class="sr-only" aria-live="polite">{{ ariaResultAlert }} results found</div>
				<table mat-table [dataSource]="dataSource" matSort appAnnounceSortChange>
					<ng-container matColumnDef="select">
						<th mat-header-cell *matHeaderCellDef></th>
						<td mat-cell *matCellDef="let row">
							<mat-checkbox
								attr.aria-label="Check box to select the {{ row.caseName }} case"
								class="margin-right-5"
								id="sys-dsb-checkbox-{{ row.caseName }}"
								(click)="$event.stopPropagation()"
								(change)="selection.toggle(row)"
								[checked]="selection.isSelected(row)"
							>
							</mat-checkbox>
						</td>
					</ng-container>

					<ng-container matColumnDef="caseName">
						<th mat-header-cell *matHeaderCellDef aria-label="Case Name">
							<div mat-sort-header sortActionDescription="Sort by case name">Case Name</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="column-case-name"
								aria-label="Filter by Case Name"
								(keyup)="applyColumnFilter($event.target.value, 'caseName')"
							/>
						</th>
						<!-- This lead column is a th in order to read this column to the user when they are tabbing through the table -->
						<th mat-cell *matCellDef="let row; let i = index" class="lead-col mat-mdc-cell">
							<a
								href="javascript:void(0)"
								class="m-focus"
								id="sys-dsb-anchor-{{ row.caseName }}"
								appDebounceClick
								(debounceClick)="$event.stopPropagation(); stepper.next(); loadCase(row)"
								>{{ row.caseName }}</a
							>
						</th>
					</ng-container>

					<ng-container matColumnDef="status">
						<th mat-header-cell *matHeaderCellDef aria-label="Status">
							<div mat-sort-header sortActionDescription="Sort by systemic case type">Systemic Case Type</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="status-column-filter"
								aria-label="Filter by Status"
								(keyup)="applyColumnFilter($event.target.value, 'status')"
							/>
						</th>
						<td mat-cell *matCellDef="let row">
							<span
								class="padding-5"
								[ngClass]="row.status?.code === 'IN' ? 'approved-status-label' : 'pending-status-label'"
							>
								{{ row.status?.description }}
							</span>
						</td>
					</ng-container>

					<ng-container matColumnDef="respondents">
						<th mat-header-cell *matHeaderCellDef aria-label="Respondent name">
							<div mat-sort-header sortActionDescription="Sort by respondent name">Respondent Name</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="respondent-name-column-filter"
								aria-label="Filter by Respondent Name"
								(keyup)="applyColumnFilter($event.target.value, 'respondents')"
							/>
						</th>
						<td mat-cell *matCellDef="let row">{{ row.caseCriteria?.respondents?.join(', ') }}</td>
					</ng-container>

					<ng-container matColumnDef="statute">
						<th mat-header-cell *matHeaderCellDef aria-label="statute">
							<div mat-sort-header sortActionDescription="Sort by statute">Statute</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="statute-column-filter"
								aria-label="Filter by Statute"
								(keyup)="applyColumnFilter($event.target.value, 'statute')"
							/>
						</th>
						<td mat-cell *matCellDef="let row" class="allegation-display">
							{{ convertAllegationsToDescription(row.caseCriteria?.statute, statuteLookup) }}
						</td>
					</ng-container>

					<ng-container matColumnDef="basis">
						<th mat-header-cell *matHeaderCellDef aria-label="basis">
							<div mat-sort-header sortActionDescription="Sort by basis">Basis</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="basis-column-filter"
								aria-label="Filter by Basis"
								(keyup)="applyColumnFilter($event.target.value, 'basis')"
							/>
						</th>
						<td mat-cell *matCellDef="let row" class="allegation-display">
							{{ convertAllegationsToDescription(row.caseCriteria?.basis, basisLookup) }}
						</td>
					</ng-container>

					<ng-container matColumnDef="issue">
						<th mat-header-cell *matHeaderCellDef aria-label="issue">
							<div mat-sort-header sortActionDescription="Sort by issue">Issue</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="issue-column-filter"
								aria-label="Filter by Issue"
								(keyup)="applyColumnFilter($event.target.value, 'issue')"
							/>
						</th>
						<td mat-cell *matCellDef="let row" class="allegation-display">
							{{ convertAllegationsToDescription(row.caseCriteria?.issue, issueLookup) }}
							{{ row.additionalIssues ? ',\n' + row.additionalIssues : null }}
						</td>
					</ng-container>

					<ng-container matColumnDef="owner">
						<th mat-header-cell *matHeaderCellDef aria-label="case owner">
							<div mat-sort-header sortActionDescription="Sort by case owner">Case Owner</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="case-owner-column-filter"
								aria-label="Filter by Case Owner"
								(keyup)="applyColumnFilter($event.target.value, 'owner')"
							/>
						</th>
						<td mat-cell *matCellDef="let row">{{ row.owner }}</td>
					</ng-container>

					<ng-container matColumnDef="office">
						<th mat-header-cell *matHeaderCellDef aria-label="owner's office">
							<div mat-sort-header sortActionDescription="Sort by owner's office">Owner's Office</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="owners-office-column-filter"
								aria-label="Filter by Owner's Office"
								(keyup)="applyColumnFilter($event.target.value, 'office')"
							/>
						</th>
						<td mat-cell *matCellDef="let row">{{ row.office?.description }}</td>
					</ng-container>

					<ng-container matColumnDef="numberOfCharges">
						<th mat-header-cell *matHeaderCellDef aria-label="Number of cases">
							<div mat-sort-header sortActionDescription="Sort by number of cases"># of Cases</div>
							<input
								class="column-filter"
								(click)="$event.stopPropagation()"
								id="number-of-cases-column-filter"
								aria-label="Filter by Number of Cases"
								(keyup)="applyColumnFilter($event.target.value, 'numberOfCharges')"
							/>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="margin-left-15">
								{{ row.numberOfCharges }}
							</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="subscribed">
						<th mat-header-cell *matHeaderCellDef aria-label="subscribed">
							<div class="filter-less-header">Subscribed</div>
						</th>
						<td mat-cell *matCellDef="let row" class="d-flex justify-content-center">
							<mat-icon
								mat-mini-fab
								color="primary"
								class="margin-top-15"
								*ngIf="isUserSubscribed(row?.systemicCaseId)"
								matTooltip="Subscribed"
								appAnnounceTooltip="Subscribed"
							>done</mat-icon>
						</td>
					</ng-container>

					<ng-container matColumnDef="actions">
						<th mat-header-cell *matHeaderCellDef style="width: 70px" aria-label="Action">
							<div class="filter-less-header">Action</div>
						</th>
						<td mat-cell *matCellDef="let row" class="pull-text-right">
							<button
								mat-icon-button
								color="primary"
								id="sys-dsb-updateNotes-{{ row.systemicCaseId }}"
								[matMenuTriggerFor]="menu"
								(click)="updateNotes(row.systemicCaseId)"
								aria-label="More Actions"
								matTooltip="Actions"
								appAnnounceTooltip="Actions"
							>
								<mat-icon>more_vert</mat-icon>
							</button>
							<mat-menu #menu="matMenu">
								<button
									mat-menu-item
									id="sys-dsb-navigateToSystemicModule-{{ row.systemicCaseId }}"
									*ngIf="!isSystemicModule"
									appDebounceClick
									(debounceClick)="navigateToSystemicModule(row.systemicCaseId)"
								>
									Go To Case
								</button>
								<button
									mat-menu-item
									id="sys-dsb-modifyCase-{{ row.systemicCaseId }}"
									*ngIf="isSystemicModule"
									[disabled]="!isEnableDelete([row])"
									appDebounceClick
									(debounceClick)="modifyCase(row.systemicCaseId, row)"
								>
									Modify case
								</button>
								<button
									mat-menu-item
									*ngIf="isSystemicModule"
									id="sys-dsb-remove-{{ row.systemicCaseId }}"
									[disabled]="!isEnableDelete([row])"
									appDebounceClick
									(debounceClick)="confirmRemoveSystemicCases([row], 'remove')"
								>
									Remove
								</button>
								<button
									mat-menu-item
									*ngIf="isSystemicModule"
									id="sys-dsb-delete-{{ row.systemicCaseId }}"
									[disabled]="!isEnableDelete([row])"
									appDebounceClick
									(debounceClick)="confirmRemoveSystemicCases([row], 'delete')"
								>
									Close
								</button>
								<button
									mat-menu-item
									*ngIf="isSystemicModule"
									id="sys-dsb-addNotes-{{ row.systemicCaseId }}"
									[disabled]="!isEnableDelete([row])"
									appDebounceClick
									(debounceClick)="openNotesDialog(row.systemicCaseId)"
								>
									Add Notes
								</button>
								<button
									mat-menu-item
									id="sys-dsb-confirmSubscribe-{{ row.systemicCaseId }}"
									*ngIf="!isUserSubscribed(row?.systemicCaseId)"
									appDebounceClick
									(debounceClick)="confirmSubscribe(row)"
								>
									Subscribe
								</button>
								<button
									mat-menu-item
									*ngIf="isUserSubscribed(row?.systemicCaseId)"
									id="sys-dsb-confirmUnsubscribe-{{ row.systemicCaseId }}"
									appDebounceClick
									(debounceClick)="confirmUnsubscribe(row)"
								>
									Unsubscribe
								</button>
							</mat-menu>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
					<tr
						class="mat-table-row"
						mat-row
						*matRowDef="let row; columns: displayColumns"
						[ngClass]="{ 'mat-table-row-selected': selection.isSelected(row) }"
						appDebounceClick
						(debounceClick)="selection.toggle(row)"
					></tr>
				</table>
			</div>
			<div
				*ngIf="systemicCaseArray && systemicCaseArray.length === 0"
				class="margin-left-20 margin-top-10 margin-bottom-10"
			>
				No records found.
			</div>
			<mat-paginator [pageSizeOptions]="[25, 50, 75, 100, 150]" [showFirstLastButtons]="true" [pageSize]="25" ></mat-paginator>
		</mat-step>
		<mat-step label="detail">
			<div class="top-bar" fxLayout="row" fxLayoutAlign="space-around center">
				<div fxFlex="90">
					<a
						class="margin-left-15"
						href="javascript:void(0)"
						id="sys-dsb-all-systemic"
						appDebounceClick
						(debounceClick)="$event.stopPropagation(); stepper.previous(); clearDetailTable()"
					>
						All Systemic Cases
					</a>
					<span>&nbsp;/&nbsp;</span>
					<span *ngIf="systemicDetail">
						<strong>{{ systemicDetail.systemicCase?.caseName.toUpperCase() }}&nbsp;&nbsp;</strong>
						<span
							[ngClass]="
								systemicDetail.systemicCase?.status?.code === 'IN' ? 'approved-status-label' : 'pending-status-label'
							"
						>
							{{ systemicDetail.systemicCase?.status?.description }}
						</span>
					</span>
				</div>
				<div fxFlex="auto" class="pull-text-right d-flex align-items-center">
					<button
						mat-flat-button
						class="margin-left-10 more mat-button-md btn-subscribe"
						(mouseover)="buttonText = !isSubscribed ? 'Subscribe' : 'Unsubscribe'"
						(mouseleave)="buttonText = isSubscribed ? 'Subscribed' : 'Unsubscribed'"
						id="sys-dsb-toggleSubscription-btn"
						appDebounceClick
						(debounceClick)="toggleSubscription(systemicDetail?.systemicCase?.systemicCaseId)"
					>
						{{ buttonText }}
					</button>

					<button
						mat-flat-button
						color="primary"
						class="margin-10 mat-button-md"
						id="sys-dsb-edit-btn"
						*ngIf="isSystemicModule && selectedCase?.status?.code !== 'IN'"
						appDebounceClick
						(debounceClick)="modifyCase(systemicDetail?.systemicCase?.systemicCaseId)"
					>
						View / Edit Sytemic case
					</button>
					<button
						mat-mini-fab
						color="primary"
						class="margin-10"
						id="sys-dsb-exportToCsv-btn"
						appDebounceClick
						(debounceClick)="download('csv', systemicDetail.systemicCase?.caseName)"
						matTooltip="Export to CSV"
						appAnnounceTooltip="Export to CSV"
						aria-label="Export to CSV"
					>
						<mat-icon>file_download</mat-icon>
					</button>
				</div>
			</div>
			<mat-tab-group animationDuration="0ms">
				<mat-tab label="Details">
					<ng-template matTabContent>
						<app-systemic-detail
							[selectedCase]="selectedCase"
							[systemicCaseCharges]="relatedSystemicCaseCharges"
							[isSystemicModule]="isSystemicModule"
							[systemicCaseId]="currentSystemicCaseId"
							[systemicNotes]="notes"
							[allCharges]="systemicCaseCharges"
							[showActions]="true"
							#detail
							[isSystemicManager]="isEnableDelete([systemicDetail?.systemicCase])"
							(onSave)="loadCase(selectedCase)"
						>
						</app-systemic-detail>
					</ng-template>
				</mat-tab>
				<mat-tab label="Removed Results" *ngIf="systemicDetail?.systemicCase?.status?.code !== 'IN'">
					<ng-template matTabContent>
						<app-systemic-detail
							[selectedCase]="selectedCase"
							[systemicCaseCharges]="notRelatedSystemicCaseCharges"
							[isSystemicModule]="isSystemicModule"
							[systemicCaseId]="currentSystemicCaseId"
							[systemicNotes]="notes"
							[allCharges]="systemicCaseCharges"
							[showActions]="false"
							#detail
							[isSystemicManager]="isEnableDelete([systemicDetail?.systemicCase])"
							(onSave)="loadCase(selectedCase)"
						>
						</app-systemic-detail>
					</ng-template>
				</mat-tab>
				<mat-tab label="Activity Log" *ngIf="false">
					<ng-template matTabContent>
						<app-shared-activity-log [logs]="logs"></app-shared-activity-log>
					</ng-template>
				</mat-tab>
				<mat-tab label="Documents" *ngIf="hasEditRight && systemicDetail?.systemicCase?.status?.code === 'IN'">
					<ng-template matTabContent>
						<div>
							<app-upload-documents
								[isSystemic]="true"
								[systemicCase]="systemicDetail?.systemicCase"
								[documentTypes]="documentTypes"
								(docChange)="doclist?.getSystemicDocuments(2000)"
							></app-upload-documents>
						</div>
						<div>
							<app-document-list
								[isSystemic]="true"
								#doclist
								[parent]="parent"
								[systemicCase]="systemicDetail?.systemicCase"
								(onInit)="onDocumentsInit($event)"
							></app-document-list>
						</div>
					</ng-template>
				</mat-tab>
			</mat-tab-group>
		</mat-step>
	</mat-horizontal-stepper>
</div>
